import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; // <-- Import CommonModule here
import { Navbar } from './navbar';
import { ChildScene } from "./land copy";
import { Wwww } from "./land copy 2";
import { MultiTrackAudioPlayerComponent } from "./audio";
import { WwwwwwComponent } from "./bottom";
import { isAuth } from './auth';

@Component({
  selector: 'app-inicio',
  standalone: true,
  imports: [
    CommonModule, // <-- Include CommonModule in the imports array
    Navbar, 
    ChildScene, 
    Wwww, 
    MultiTrackAudioPlayerComponent, 
    WwwwwwComponent
  ],
  template: `
    <app-navbar></app-navbar>
    <app-www></app-www>   
    <main class="container p-1 bg-light">
      <app-child-scene></app-child-scene>
      <app-multi-track-audio-player></app-multi-track-audio-player>
    </main>
    <app-wwwwww></app-wwwwww>
  `
})
export class Inicio {
  auth: any = isAuth();
}